import { components, operations } from "../types/openapi";

export type ReportEntity = components["schemas"]["ReportDto"];
export type S3FileType = operations["uploadDoc"]["parameters"]["query"]["type"];
export type DocDto = components["schemas"]["DocDto"];
export type DocumentDto = components["schemas"]["DocumentDto"];
export type DocUploadedResponse = components["schemas"]["DocUploadedResponse"];

export const REPORT_TYPE_ENUM = {
  TX: "tx",
  FEE_CUR: "fee-cur",
  REQUESTS: "requests",
  WALLETS: "wallets",
  CLIENTS: "companies",
  AGGREGATED: "companies-total",
  FEE_CUR_ALL: "fee-cur-all",
  REMAINING_AND_OPERATIONS: "company-balance",
  REQUEST_FEES: "request-fees",
};

export const FILE_TYPE_ENUM: Record<S3FileType, S3FileType> = {
  CONTRACT: "CONTRACT",
  FEE_CURRENCY_REPORT: "FEE_CURRENCY_REPORT",
  REQUEST_REPORT: "REQUEST_REPORT",
  TX_REPORT: "TX_REPORT",
  AGENT_ASSIGNMENT: "AGENT_ASSIGNMENT",
  AGENT_ASSIGNMENT_SIGNED: "AGENT_ASSIGNMENT_SIGNED",
  AGENT_CONTRACT: "AGENT_CONTRACT",
  AGENT_CONTRACT_SIGNED: "AGENT_CONTRACT_SIGNED",
  INVOICE: "INVOICE",
  OFFER: "OFFER",
  OFFER_SIGNED: "OFFER_SIGNED",
  REPORT_REQUESTS: "REPORT_REQUESTS",
  REPORT_WALLETS: "REPORT_WALLETS",
  REPORT_COMPANIES: "REPORT_COMPANIES",
  REPORT_COMPANIES_TOTAL: "REPORT_COMPANIES_TOTAL",
  REPORT_REQUESTS_BY_CONTRACT: "REPORT_REQUESTS_BY_CONTRACT",
  DKP: "DKP",
  PP_CUSTOMER: "PP_CUSTOMER",
  PP_LP: "PP_LP",
  ADDITIONAL_DOC: "ADDITIONAL_DOC",
  FEE_CUR_ALL: "FEE_CUR_ALL",
  RUB_TX_REPORT: "RUB_TX_REPORT",
  LP_RUB_TX_REPORT: "LP_RUB_TX_REPORT",
  CUSTOMER_RUB_TX_REPORT: "CUSTOMER_RUB_TX_REPORT",
  CUSTOMER_REPORT_REQUESTS: "CUSTOMER_REPORT_REQUESTS",
  FAVICON: "FAVICON",
  LOGO: "LOGO",
  REPORT_COMPANY_BALANCE: "REPORT_COMPANY_BALANCE",
};

export interface FileRule {
  type: S3FileType;
  label: string;
  canUpload: boolean;
  canRemove: boolean;
  visible: boolean;
  multipleUpload: {
    canLoadAgain: boolean;
    multiple: boolean;
  };
}

export enum TEMPLATE_FORMAT_ENUM {
  SHEET = "SHEET",
  DOC = "DOC",
}
